import { useApolloClient } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';
import { MemberValuesFragment } from './member.fragments';

export const GET_ACCOUNT_MEMBERS_EXPORT = gql`
  query GetAccountMembersExport($input: AccountMembersInput!) {
    getAccountMembers(input: $input) {
      count
      results {
        ...memberValues
      }
    }
  }
  ${MemberValuesFragment}
`;

export const GET_ACCOUNT_ANNUALS_EXPORT = gql`
  query GetAccountAnnualsExport($input: AccountMembersInput!) {
    getAccountAnnuals(input: $input) {
      count
      results {
        ...memberValues
      }
    }
  }
  ${MemberValuesFragment}
`;

export function useGetAccountMembersReport({
  account_id,
  year,
  queryString,
  ticket_id,
  type,
  start_date,
  end_date,
}) {
  const client = useApolloClient();

  const result = useCallback(async () => {
    const query =
      'annual' === type
        ? GET_ACCOUNT_ANNUALS_EXPORT
        : GET_ACCOUNT_MEMBERS_EXPORT;
    const responseKey =
      'annual' === type ? 'getAccountAnnuals' : 'getAccountMembers';

    const input = {
      account_id,
      year,
      ...(queryString ? { queryString } : null),
      ...(ticket_id ? { ticket_id } : null),
      ...(type ? { type } : null),
      ...(start_date ? { start_date } : null),
      ...(end_date ? { end_date } : null),
      page: '1',
      limit: '1',
    };

    const countResponse = await client.query({
      query,
      variables: { input },
      fetchPolicy: 'network-only',
    });

    const count = countResponse?.data?.[responseKey]?.count ?? 0;

    if (!count) {
      return {
        data: {
          getAccountMembersReport: {
            count: 0,
            results: [],
          },
        },
      };
    }

    const fullResponse = await client.query({
      query,
      variables: {
        input: {
          ...input,
          limit: String(count),
        },
      },
      fetchPolicy: 'network-only',
    });

    return {
      data: {
        getAccountMembersReport: fullResponse?.data?.[responseKey] ?? {
          count: 0,
          results: [],
        },
      },
    };
  }, [
    client,
    account_id,
    year,
    queryString,
    ticket_id,
    type,
    start_date,
    end_date,
  ]);

  return result;
}
